﻿import React, { useState, useEffect } from 'react';
import { Scanner } from '@yudiel/react-qr-scanner';

export default function BarCodeScannerDemo() {
    const [scannerValue, setScannerValue] =
        useState<string>();

    return (
        <div>
            <div className="lq-title-bar">
                <div className="lq-main-title">QR Code Scanner</div>
            </div>

            <div>Try with a smart phone</div>

            <Scanner onResult={onScannerResult}
                onError={onScannerError} />

             <div>
                <div>Value Read:</div>
                <div>{scannerValue}</div>
             </div>
        </div>
    );

    function onScannerResult(text: string, result:any) {
        console.log(text, result);

        setScannerValue(text);
    }

    function onScannerError(error: any) {
        console.log(error);
    }

}